import React from 'react';
import { Link } from 'react-router-dom';
import FormArea from './form';

const ContactMain = () => {
    return (
        <>
            <style>
                {`
                    .contact-link {
                        color: inherit;
                        text-decoration: none;
                        transition: color 0.3s ease;
                        display: block;
                    }
                    .contact-link:hover {
                        color: #0E357B !important;
                        text-decoration: none;
                    }
                    .contact-link:hover p {
                        color: #0E357B !important;
                    }
                    .contact-box {
                        border: 1px solid #eee;
                        border-radius: 10px;
                        box-shadow: 0 0 15px rgba(0,0,0,0.1);
                        transition: all 0.3s ease;
                    }
                    .contact-box:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 5px 20px rgba(0,0,0,0.15);
                    }
                    .map-container {
                        width: 100%;
                        height: 600px;
                        border-radius: 10px;
                        overflow: hidden;
                        margin-top: 30px;
                    }
                    .map-container iframe {
                        width: 100%;
                        height: 100%;
                        border: none;
                    }
                    .contact-text {
                        transition: color 0.3s ease;
                        color: #555555
                    }
                    .contact__area-left-contact-item-icon i {
                        color: #333333;
                    }
                `}
            </style>
            <div className="contact__area section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="contact__area-left">
                                <div className="row">
                                    <div className="col-lg-4 col-md-4 mb-4">
                                        <div className="contact-box text-center p-3 h-100">
                                            <div className="contact__area-left-contact-item-icon mt-4">
                                            <i class="fa-regular fa-phone-volume"></i>
                                            </div>
                                            <div className="contact__area-left-contact-item-content text-center">
                                                <span className="d-block mb-3 mt-3">Telefon</span>
                                                <div className="text-center">
                                                    <Link to="tel:+90 (216) 416 88 91" className="contact-link">
                                                        <p className="mb-0 contact-text">+90 (216) 416 88 91</p>
                                                    </Link>
                                                    <Link to="tel:+90 (216) 416 88 92" className="contact-link">
                                                        <p className="mb-4 contact-text mt-2">+90 (216) 416 88 92</p>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 mb-4">
                                        <div className="contact-box text-center p-3 h-100">
                                            <div className="contact__area-left-contact-item-icon mt-4">
                                            <i class="fa-regular fa-envelope"></i>
                                            </div>
                                            <div className="contact__area-left-contact-item-content text-center">
                                                <span className="d-block mb-3 mt-3">E-Posta</span>
                                                <div className="text-center">
                                                    <Link to="mailto:info@ayyildizinsaat.com.tr" className="contact-link">
                                                        <p className="mb-4 contact-text">info@ayyildizinsaat.com.tr</p>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 mb-4">
                                        <div className="contact-box text-center p-3 h-100">
                                            <div className="contact__area-left-contact-item-icon mt-4">
                                            <i class="fa-regular fa-location-dot"></i>
                                            </div>
                                            <div className="contact__area-left-contact-item-content text-center">
                                                <span className="d-block mb-3 mt-3">Adres</span>
                                                <div className="text-center">
                                                    <Link to="https://www.google.com/maps/place/Ayy%C4%B1ld%C4%B1z+%C4%B0n%C5%9Faat/@40.9805372,29.0927144,3a,75y,95.05h,88.9t/data=!3m7!1e1!3m5!1sWOh9e36P74AD-E9a3eY6lg!2e0!6shttps:%2F%2Fstreetviewpixels-pa.googleapis.com%2Fv1%2Fthumbnail%3Fcb_client%3Dmaps_sv.tactile%26w%3D900%26h%3D600%26pitch%3D1.1000136120565287%26panoid%3DWOh9e36P74AD-E9a3eY6lg%26yaw%3D95.05262803614062!7i16384!8i8192!4m6!3m5!1s0x24929c0c07dc2241:0x9d7a9aac2dd7e9ab!8m2!3d40.9790335!4d29.0922015!16s%2Fg%2F11nc41xg01?entry=ttu&g_ep=EgoyMDI2MDYyNC4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer" className="contact-link">
                                                        <p className="mb-4 contact-text">19 Mayıs Mahallesi, Turaboğlu Sokak, Sümko Sitesi, A4 Blok No: 1-C, İç Kapı No: 13, Kozyatağı/İstanbul</p>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="map-container">
                                    <iframe 
                                        src="https://www.google.com/maps/embed/v1/place?q=40.9803742,29.092811&zoom=17&maptype=roadmap&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8" 
                                        allowFullScreen="" 
                                        loading="lazy"
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>         
        </>
    );
};

export default ContactMain;